import React from "react";
import { WifiOff } from "lucide-react";

const Dot = ({ delay = "0ms" }) => (
  <span
    className="inline-block w-1.5 h-1.5 rounded-full bg-white/60 animate-bounce"
    style={{ animationDelay: delay }}
  />
);

const OfflineOverlay = ({ isAdmin = false }) => {
  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center p-6 bg-black">
      <div
        className={`w-full max-w-md border rounded-3xl shadow-2xl overflow-hidden ${
          isAdmin
            ? "bg-[#1A1C25] border-white/10"
            : "bg-[#111111] border-white/10"
        }`}
      >
        <div className="p-7">
          <div className="flex items-center gap-4">
            <div className="relative">
              <div className="absolute inset-0 rounded-2xl bg-[#F4B400]/20 blur-xl" />
              <div className="relative p-4 rounded-2xl bg-[#F4B400]/15 text-[#F4B400] border border-[#F4B400]/25">
                <WifiOff size={26} />
              </div>
            </div>

            <div className="flex-1">
              <h2 className="font-inter font-black uppercase tracking-widest text-sm text-white">
                You&apos;re Offline
              </h2>
              <p className="mt-2 text-white/60 text-sm font-inter leading-relaxed">
                No internet connection detected. Reconnect to continue using the
                site.
              </p>
              <div className="mt-4 flex items-center gap-2 text-white/50 text-xs font-inter">
                <span>Waiting to reconnect</span>
                <div className="flex items-center gap-1">
                  <Dot delay="0ms" />
                  <Dot delay="120ms" />
                  <Dot delay="240ms" />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 bg-white/5 border border-white/10 rounded-2xl p-4">
            <p className="text-[11px] text-white/50 font-inter leading-relaxed">
              Tip: If you&apos;re on mobile data, make sure your browser has
              permission to use it. This screen will disappear automatically
              once you&apos;re back online.
            </p>
          </div>
        </div>

        <div className="h-1 w-full bg-white/5 overflow-hidden">
          <div className="h-full w-1/3 bg-[#F4B400] animate-[pulse_1.2s_ease-in-out_infinite]" />
        </div>
      </div>
    </div>
  );
};

export default OfflineOverlay;

